import React from "react";
import classNames from "classnames/bind";
import styles from "./ProductDetail.module.scss";
import { FaPlus, FaFilePdf, FaTrashAlt } from "react-icons/fa";

const cx = classNames.bind(styles);

export default function ProductDetail({
  id,
  data,
  categories,
  selectedKoCategory,
  selectedEnCategory,
  handleKoCategoryChange,
  handleEnCategoryChange,
  handleChange,
  koPdfRef,
  enPdfRef,
  handleKoPdfUpload,
  handleEnPdfUpload,
  handleKoPdfChange,
  handleEnPdfChange,
  handleDeleteKoPdf,
  handleDeleteEnPdf,
  handleSubmit,
}) {
  /** ✅ PDF 표시 컴포넌트 */
  const renderPdfBox = (file, locale) => {
    if (!file) return null;

    const isFile = file instanceof File;
    const fileName = isFile ? file.name : file.split("/").pop();
    const fileUrl = isFile
      ? URL.createObjectURL(file)
      : `https://api.kcmc.im${file}`;

    return (
      <div className={cx("pdf_box")}>
        <button
          type="button"
          className={cx("delete_btn")}
          onClick={() =>
            locale === "ko" ? handleDeleteKoPdf() : handleDeleteEnPdf()
          }
        >
          <FaTrashAlt />
        </button>
        <FaFilePdf className={cx("pdf_icon")} />

        {/* ✅ 클릭 시 바로 다운로드 */}
        <a
          href={fileUrl}
          download={fileName}
          target="_blank"
          rel="noopener noreferrer"
          className={cx("pdf_name")}
        >
          {fileName}
        </a>
      </div>
    );
  };

  return (
    <>
      <div className={cx("inner", "wrapper")}>
        <div className={cx("title_box")}>
          <p className={cx("title")}>한국어</p>
        </div>
        <div className={cx("input_inner")}>
          <div className={cx("input_box")}>
            <p className={cx("label")}>카테고리</p>
            <select
              className={cx("input")}
              value={selectedKoCategory}
              onChange={handleKoCategoryChange}
            >
              <option value="">카테고리를 선택해 주세요.</option>
              {categories.ko.map((category) => (
                <option key={category.id} value={category.id}>
                  {category.label}
                </option>
              ))}
            </select>
          </div>
          <div className={cx("input_box")}>
            <p className={cx("label")}>제품명</p>
            <input
              type="text"
              className={cx("input")}
              name="product_name"
              value={data?.ko?.product_name || ""}
              onChange={(e) => handleChange("ko", e)}
              placeholder="제품명을 입력해 주세요."
            />
          </div>
        </div>
        <div className={cx("input_inner")}>
          <div className={cx("input_box")}>
            <p className={cx("label")}>CAS No</p>
            <input
              type="text"
              className={cx("input")}
              name="cas_no"
              value={data?.ko?.cas_no || ""}
              onChange={(e) => handleChange("ko", e)}
              placeholder="CAS No를 입력해 주세요."
            />
          </div>
          <div className={cx("input_box")}>
            <p className={cx("label")}>포장 단위</p>
            <input
              type="text"
              className={cx("input")}
              name="pack_unit"
              value={data?.ko?.pack_unit || ""}
              onChange={(e) => handleChange("ko", e)}
              placeholder="포장 단위를 입력해 주세요."
            />
          </div>
        </div>
        <div className={cx("input_inner")}>
          <div className={cx("input_box")}>
            <p className={cx("label")}>설명</p>
            <input
              type="text"
              className={cx("input")}
              name="usage_text"
              value={data?.ko?.usage_text || ""}
              onChange={(e) => handleChange("ko", e)}
              placeholder="설명을 입력해 주세요."
            />
          </div>
          <div className={cx("input_box")}>
            <p className={cx("label")}>문서 (PDF)</p>
            <div className={cx("pdf_upload_area")}>
              <button
                type="button"
                className={cx("image_button")}
                onClick={handleKoPdfUpload}
              >
                <FaPlus className={cx("image_button_icon")} />
              </button>
              <input
                type="file"
                accept="application/pdf"
                ref={koPdfRef}
                className={cx("input", "hide_input")}
                onChange={handleKoPdfChange}
              />
              {data?.ko?.doc_path && renderPdfBox(data.ko.doc_path, "ko")}
            </div>
          </div>
        </div>
      </div>
      <div className={cx("inner")}>
        <div className={cx("title_box")}>
          <p className={cx("title")}>영문</p>
        </div>
        <div className={cx("input_inner")}>
          <div className={cx("input_box")}>
            <p className={cx("label")}>카테고리</p>
            <select
              className={cx("input")}
              value={selectedEnCategory}
              onChange={handleEnCategoryChange}
            >
              <option value="">카테고리를 선택해 주세요.</option>
              {categories.en.map((category) => (
                <option key={category.id} value={category.id}>
                  {category.label}
                </option>
              ))}
            </select>
          </div>
          <div className={cx("input_box")}>
            <p className={cx("label")}>제품명</p>
            <input
              type="text"
              className={cx("input")}
              name="product_name"
              value={data?.en?.product_name || ""}
              onChange={(e) => handleChange("en", e)}
              placeholder="제품명을 입력해 주세요."
            />
          </div>
        </div>
        <div className={cx("input_inner")}>
          <div className={cx("input_box")}>
            <p className={cx("label")}>CAS No</p>
            <input
              type="text"
              className={cx("input")}
              name="cas_no"
              value={data?.en?.cas_no || ""}
              onChange={(e) => handleChange("en", e)}
              placeholder="CAS No를 입력해 주세요."
            />
          </div>
          <div className={cx("input_box")}>
            <p className={cx("label")}>포장 단위</p>
            <input
              type="text"
              className={cx("input")}
              name="pack_unit"
              value={data?.en?.pack_unit || ""}
              onChange={(e) => handleChange("en", e)}
              placeholder="포장 단위를 입력해 주세요."
            />
          </div>
        </div>
        <div className={cx("input_inner")}>
          <div className={cx("input_box")}>
            <p className={cx("label")}>설명</p>
            <input
              type="text"
              className={cx("input")}
              name="usage_text"
              value={data?.en?.usage_text || ""}
              onChange={(e) => handleChange("en", e)}
              placeholder="설명을 입력해 주세요."
            />
          </div>
          <div className={cx("input_box")}>
            <p className={cx("label")}>문서 (PDF)</p>
            <div className={cx("pdf_upload_area")}>
              <button
                type="button"
                className={cx("image_button")}
                onClick={handleEnPdfUpload}
              >
                <FaPlus className={cx("image_button_icon")} />
              </button>
              <input
                type="file"
                accept="application/pdf"
                ref={enPdfRef}
                className={cx("input", "hide_input")}
                onChange={handleEnPdfChange}
              />
              {data?.en?.doc_path && renderPdfBox(data.en.doc_path, "en")}
            </div>
          </div>
        </div>
      </div>
      <div className={cx("button_box")}>
        <button className={cx("button")} onClick={handleSubmit}>
          품목 {id ? "수정" : "추가"}
        </button>
      </div>
    </>
  );
}
